import React, { useState, useEffect, useLayoutEffect } from "react";
import {
  AutoComplete,
  Breadcrumb,
  Modal,
  Popover,
  Select,
  Switch,
  Tabs,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import images from "../../themes/appImage";
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";
import {
  emailSearchLoad,
  freezeModalFirstHandler,
  freezeModalSecondHandler,
  freezeProfileLoad,
  makeSuperUserLoad,
  removeProfileLoad,
  removeProfileModal,
  userDetailLoad,
} from "../../redux/slices/user.slice";
import { useDispatch, useSelector } from "react-redux";
import { imageURL } from "../../redux/Api/apikit";
import moment from "moment";
import { debounce } from "../../utils/global-func";
import Posts from "./Post/Posts";
import "../../css/style.css"
import { capitalizeFirstLetter } from "../../utils";

const AddUsers = () => {
  const state = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId } = state.state;
  const {
    userDetailData,
    freezeProfileFirstModalState,
    freezeProfileSecondModalState,
    emailList,
    removeProfileModalState,
    removeProfileSuccess,
  } = useSelector((state) => state.userReducer);
  const categoryList = userDetailData && userDetailData?.userSelectedCategory && userDetailData?.userSelectedCategory[0]?.categoryInfo.map((item) => item?.name)

  const groups = userDetailData?.encouragementGroup;
  const innerData = userDetailData?.innerCircle;
  const [freezProfilePayload, setFreezeProfilePayload] = useState({
    email: "",
    freezeDay: "",
    addNewPost: false,
    addComment: false,
  });
  const [removeProfileEmail, setRemoveProfileEmail] = useState({ id: "" });

  useLayoutEffect(() => {
    dispatch(userDetailLoad({ userId }));
  }, []);

  const [input, setInput] = useState(userDetailData.email);

  useEffect(() => {
    if (removeProfileSuccess) {
      setInput("");
      setRemoveProfileEmail({ id: "" });
      setFreezeProfilePayload({
        email: "",
        freezeDay: "",
        addNewPost: false,
        addComment: false,
      });
    }
  }, [removeProfileSuccess]);


  const [modal5Open, setModal5Open] = useState(false);

  const FreezeAccountHanlder = () => {
    const payload = {
      day: Number(freezProfilePayload.freezeDay),
      userId: freezProfilePayload.email,
      postFreeze: freezProfilePayload.addNewPost,
      commentFreeze: freezProfilePayload.addComment,
    };
    dispatch(freezeProfileLoad(payload));
  };
  const removeAccountHandler = () => {
    dispatch(removeProfileLoad(removeProfileEmail));
  };

  const handleSearch = (value) => {
    debounce(() => dispatch(emailSearchLoad({ email: value })));
  };

  const handleSelect = (value, option) => {
    setInput(option.label);
    setFreezeProfilePayload((prev) => ({ ...prev, email: option.value }));
  };

  const handlerRemoveSelect = (value, option) => {
    setInput(option.label);
    setRemoveProfileEmail({ id: option.value });
  };

  const handleInput = (value) => {
    setInput(value);
    value?.length > 0 && handleSearch(value);
  };
  const options = emailList.map((email) => ({
    value: email._id,
    label: email.email,
  }));

  const handleClick = (id) => {
    navigate('/innercircletabs', {
      state: {
        id: id,
      }
    })

  }
  return (
    <div>
      <div className="site-layout-background" style={{ minHeight: 360 }}>
        <div className="top-header-organi-zations">
          <div className="organi-zations-heading-text">
            <h1>Users</h1>
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <Link to="/users"> Users </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{appconstant.addUser}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>

        <div className="user-main-section">
          <div className="user-profile-div">
            <div className="user-left-side-sec">
              <div className="inner-section-ps">
                <div className="flex justify-center items-center pt-4">
                  <img
                    className="w-16 !important h-16 !important rounded-[100%] object-contain"
                    src={`${imageURL}${userDetailData.avatar}`}
                    alt="profileSec"
                  />
                </div>
                <div className="avatar-name">
                  <h2>
                    {userDetailData.firstName} {userDetailData.lastName}
                  </h2>
                  <p>{userDetailData.userName}</p>
                  <div className="avatar-ranking">
                    <img src={images.welcomeIcon} alt="welcomeIcon" />
                    <img src={images.thoughtIcon} alt="thoughtIcon" />
                    <img src={images.goalIcon} alt="goalIcon" />
                  </div>
                </div>
                <div className="followers-section">
                  <div className="avatar-post-numbers">
                    <div className="following-div border-line">
                      <p>{userDetailData?.followers || 0}</p>
                      <span>Followers</span>
                    </div>
                    <div className="following-div border-line">
                      <p>{userDetailData?.userPost?.length || 0}</p>
                      <span>Posts</span>
                    </div>
                    <div className="following-div">
                      <p>{userDetailData?.followings || 0}</p>
                      <span>Following</span>
                    </div>
                  </div>
                </div>
                <div className="w-full px-3 py-4 border-b  flex justify-between items-center">
                  <div className="flex items-center gap-2">
                    <img src={images.goldStart} className="w-4 h-4 " />
                    <div className="text-sm font-medium">Super User</div>
                  </div>
                  <div className="flex gap-1 items-center">
                    <Switch
                      className="superUserButton"
                      checked={userDetailData.isSuperUser}
                      onChange={() => dispatch(makeSuperUserLoad({ userId }))} />
                    <div className="text-sm font-medium">Yes</div>
                  </div>

                </div>
                <div className="work-on-most">
                  <h1>Things I would like to work on most</h1>

                  <div className="acceptance-care">
                    <div className="beauty">
                      {categoryList?.length > 0 && categoryList?.map(item => <p>{item}</p>)}
                    </div>
                  </div>

                  <div className="top-mt">
                    <div className="coins">
                      <p>Coins</p>
                      <span>
                        <img src={images.coins} alt="coins" />
                        {userDetailData.coin}
                      </span>
                    </div>

                    <div className="coins">
                      <p>Email</p>
                      <span>{userDetailData.email}</span>
                    </div>

                    <div className="coins">
                      <p>Gender</p>
                      <span>{capitalizeFirstLetter(userDetailData.identityType)}</span>
                    </div>

                    <div className="coins">
                      <p>DOB</p>
                      <span>
                        {moment(userDetailData.dob).format("MMMM D, YYYY")}
                      </span>
                    </div>

                    <div className="coins">
                      <p>Visibility</p>
                      <span>{userDetailData?.isPrivate?.toString()}</span>
                    </div>

                    <div className="coins">
                      <p>WHO-5 Wellness Index</p>
                      <span>{userDetailData?.wellnessIndexScore}</span>
                    </div>

                    <div className="coins">
                      <p>Streak</p>
                      <span>{userDetailData.streak}</span>
                    </div>
                  </div>
                  <div className="profile-freeze">
                    <button
                      onClick={() => {
                        dispatch(freezeModalFirstHandler());
                        setInput(userDetailData?.email);
                        setFreezeProfilePayload((pre) => ({
                          ...pre,
                          email: userDetailData?._id,
                        }));
                      }}
                    >
                      Freeze Profile
                    </button>
                    <button
                      onClick={() => {
                        setInput(userDetailData?.email);
                        setRemoveProfileEmail({ id: userDetailData?._id });
                        dispatch(removeProfileModal());
                      }}
                    >
                      Remove Profile
                    </button>
                  </div>
                </div>
                <div className="bottom-text">
                  <p>
                    Member Since:{" "}
                    {moment(userDetailData.createdAt).format("MMMM D, YYYY")}{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="slider-section post-page-section">
              <div className="slider-tab-div">
                <div className="tab-bar ">
                  <Tabs>
                    <Tabs.TabPane tab="Posts" key="1">
                      <div className="post-page-width">
                        <Posts />
                      </div>
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="Inner Circles" key="2">
                      <div className="inner-circle">
                        <div className="create-inner-section "
                          style={innerData?.length == 0 ? { display: "flex", justifyContent: "center" } : {}}
                        >
                          {innerData && innerData?.length > 0 ?
                            innerData?.map((item, index) => (
                              <div
                                className="create-entertainment-circle"
                                key={index}
                              >
                                <div className="enter-flex-ps">
                                  <div className="enter-taain-heading">
                                    <h1>
                                      {item.circleDetail &&
                                        item.circleDetail.name}
                                    </h1>
                                    <p>
                                      <span>
                                        <img
                                          src={images.redDot}
                                          alt="createCricl"
                                        />
                                      </span>
                                      {item.circleDetail &&
                                        item.circleDetail.description}
                                    </p>
                                  </div>
                                  <div className="dotes-react">
                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}
                                  </div>
                                </div>
                                <div className="reation-imoze">
                                  <div className="avatars">
                                    {/* Example: Displaying first 5 avatars */}
                                    {item.creator && item.creator.avatar && (
                                      <>
                                        <span>
                                          <img src={`${imageURL}${item.creator.avatar}`} alt="Avatar" />
                                        </span>

                                        {/* <span>
                                          <img
                                            src={images.avatarTow}
                                            alt="avatarTow"
                                          />
                                        </span> */}
                                        {/* <span>
                                          <img
                                            src={images.avatarThree}
                                            alt="avatarThree"
                                          />
                                        </span> */}
                                        {/* <span>
                                          <img
                                            src={images.avatarFour}
                                            alt="avatarfour"
                                          />
                                        </span> */}
                                        {/* <span>
                                          <img
                                            src={images.avatarFive}
                                            alt="avatarfour"
                                          />
                                        </span> */}
                                        {/* <span className="get-more">
                                          +
                                          {item.creator &&
                                            item.creator.moreAvatarsCount}
                                        </span> */}
                                      </>
                                    )}
                                  </div>
                                  <div className="back-button" onClick={() => handleClick(item.circleDetail._id)}>
                                    <img
                                      src={images.backButton}
                                      alt="backButton"
                                    />
                                  </div>
                                </div>

                              </div>
                            ))
                            : <div className='w-full justify-center text-center text-black font-medium text-base'>No inner circles</div>

                          }
                        </div>
                      </div>
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="Encouragement Groups" key="3">
                      <div className="inner-circle">
                        <div className="create-inner-section encouragement-section-grid"
                          style={groups?.length == 0 ? { display: "flex", justifyContent: "center" } : {}}
                        >
                          {groups && groups?.length > 0 ?
                            groups?.map((group) => (
                              <div
                                className="create-entertainment-circle"
                                key={group._id}
                              >
                                <div className="encouragement-groups">
                                  <div className="sunday-image">
                                    <img src={images.sunday} alt="sunday" />
                                    <p>{group.groupDetail.name}</p>
                                  </div>
                                  <div className="follow-btn-ps">
                                    {/* <button>Follow</button> */}
                                  </div>
                                </div>
                              </div>
                            ))
                            : <div className='w-full justify-center text-center text-black font-medium text-base'>No encouragement groups</div>
                          }
                        </div>
                      </div>
                    </Tabs.TabPane>
                    {/* Not This Version */}
                    {/* <Tabs.TabPane tab="Direct Care Sessions" key="4">

                                                <div className="direct-care-sessions">
                                                    <div className="grid-care-sessions">
                                                        <div className="booked-sessions">
                                                            <p>Booked Sessions: <span>50</span></p>
                                                        </div>

                                                        <div className="booked-sessions">
                                                            <p>Appeared Sessions: <span>50</span> </p>
                                                        </div>

                                                        <div className="booked-sessions">
                                                            <p>Amount Spent: <span>$500</span></p>
                                                        </div>

                                                    </div>

                                                    <div className="post-detail-and-count">
                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    <img src={images.dotesReact} alt="dotesReact" />
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row  remove-margin-top">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    <img src={images.dotesReact} alt="dotesReact" />
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row  remove-margin-top">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>



                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    <img src={images.dotesReact} alt="dotesReact" />
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row  remove-margin-top">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>



                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    <img src={images.dotesReact} alt="dotesReact" />
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row  remove-margin-top">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="john-smith-post">
                                                            <div className="profile-and-name">
                                                                <div className="psychiatrist-fa-pa">
                                                                    <div className="profile-picture">
                                                                        <img src={images.userProfileScound} alt="userProfile" />
                                                                    </div>
                                                                    <div className="name-case">
                                                                        <h1>John_smith01 <span><img src={images.codiconVerified} alt="codiconVerified" /></span></h1>
                                                                        <p>Psychiatrist</p>
                                                                    </div>
                                                                </div>

                                                                <div className="options-setting-ps">
                                                                    <img src={images.dotesReact} alt="dotesReact" />
                                                                    <img src={images.signls} alt="signls" />
                                                                </div>

                                                            </div>

                                                            <div className="date-time-amount">
                                                                <div className="amount-inner-sec">
                                                                    <div className="date-row  remove-margin-top">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.grayCalender} alt="grayCalender" /></span>Date</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>March 12, 2024 </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.clockIcon} alt="clockIcon" /></span>Time</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>10:00 PM - 10:30 PM </p>
                                                                        </div>
                                                                    </div>


                                                                    <div className="date-row">
                                                                        <div className="date-icons-text">
                                                                            <p><span> <img src={images.dollar} alt="dollar" /></span>Amount</p>
                                                                        </div>
                                                                        <div className="full-date">
                                                                            <p>$50</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tabs.TabPane> */}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Freeze Account */}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={freezeProfileFirstModalState}
        closable={true}
        onCancel={() =>
          freezeProfileFirstModalState && dispatch(freezeModalFirstHandler())
        }
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Freeze Account</h1>
          </div>

          <div className="description-inner-circle">
            <div className="">
              <div className="form-group  annette-black input-hight">
                <label>{appconstant.accountEmail}</label>
                <Select
                  value={input}
                  showSearch
                  placeholder={"Search email"}
                  // style={style}
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  notFoundContent={null}
                  options={options}
                  filterOption={(inputValue, option) => {
                    const label = option.label.toLowerCase();
                    const input = inputValue.toLowerCase();
                    return label.indexOf(input) !== -1;
                  }}
                  onSelect={handleSelect}
                  onSearch={handleInput}
                />
                <p>
                  This email is associated with <span>Annette Black</span>
                </p>
              </div>
            </div>
          </div>

          <div className="account-btn">
            <button
              onClick={() => {
                dispatch(freezeModalFirstHandler());
                dispatch(freezeModalSecondHandler());
              }}
            >
              Freeze Account
            </button>
          </div>
        </div>
      </Modal>

      {/* Freeze Account  new post*/}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={freezeProfileSecondModalState}
        closable={true}
        onCancel={() =>
          freezeProfileSecondModalState && dispatch(freezeModalSecondHandler())
        }
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Freeze Account</h1>
            <div className="user-disp">
              <p>Please select that what action that user can’t perform </p>
            </div>
          </div>

          <div className="description-inner-circle">
            <div className="add-new-post-ps">
              <p>Add New Post</p>
              <Switch
                defaultChecked
                checked={freezProfilePayload.addNewPost}
                onChange={(e) =>
                  setFreezeProfilePayload((pre) => ({ ...pre, addNewPost: e }))
                }
              />
            </div>

            <div className="add-new-post-ps">
              <p>Add Comment</p>
              <Switch
                defaultChecked
                checked={freezProfilePayload.addComment}
                onChange={(e) =>
                  setFreezeProfilePayload((pre) => ({ ...pre, addComment: e }))
                }
              />
            </div>

            <div className="form-group number-of-days ">
              <label>{appconstant.noDays}</label>
              <Textfiled
                className="form-control "
                type="number"
                value={freezProfilePayload.freezeDay}
                onChange={(e) =>
                  setFreezeProfilePayload((pre) => ({
                    ...pre,
                    freezeDay: e.target.value,
                  }))
                }
                placeholder="Enter Days here"
              />

              <div className="enter-chevron-down">
                <img src={images.chevronDown} alt="chevronDown" />
                <img src={images.chevronUP} alt="chevronUP" />
              </div>
            </div>
          </div>

          <div onClick={FreezeAccountHanlder} className="account-btn">
            <button>Freeze Account</button>
          </div>
        </div>
      </Modal>

      {/* Remove post */}
      <Modal
        title=""
        className="modal-update"
        centered
        open={removeProfileModalState}
        closable={true}
        onCancel={() => dispatch(removeProfileModal())}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Remove Profile</h1>
          </div>

          <div className="description-inner-circle">
            <div className="wrapper_line">
              <div className="form-group  annette-black">
                <label>{appconstant.accountEmail}</label>
                <Select
                  value={input}
                  showSearch
                  placeholder={"Searh email"}
                  // style={style}
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  notFoundContent={null}
                  options={options}
                  filterOption={(inputValue, option) => {
                    const label = option.label.toLowerCase();
                    const input = inputValue.toLowerCase();
                    return label.indexOf(input) !== -1;
                  }}
                  onSelect={handlerRemoveSelect}
                  onSearch={handleInput}
                />
                <p>
                  This email is associated with <span>Annette Black</span>
                </p>
              </div>
            </div>
          </div>

          <div className="account-btn">
            <button onClick={removeAccountHandler}>Remove Profile</button>
          </div>
        </div>
      </Modal>

      {/* Remove post  new post*/}
      <Modal
        title=""
        className="modal-update"
        centered
        visible={modal5Open}
        closable={true}
        onCancel={() => setModal5Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Remove Post</h1>
            <div className="user-disp">
              <p>Please enter reason to remove this post </p>
            </div>
          </div>

          <div className="description-inner-circle">
            <div className="form-group">
              <div className="textarea-label">
                <label>{appconstant.message}</label>
                <p>0/500</p>
              </div>
              <textarea
                rows="5"
                cols="50"
                className="form-control-textarea"
                type="textarea"
                placeholder="Enter Description"
              />
            </div>
          </div>
          <div className="account-btn remove-post-btn">
            <button>Send</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default AddUsers;
